export default __webpack_public_path__ + "static/media/btn_webtoon_active.4f60deb4.png";